import { useBrandStore } from 'stores';
import GeneralBrandSettingsView from './GeneralBrandSettings.View';

const GeneralBrandSettings = () => {
  const { brand } = useBrandStore();
  return <GeneralBrandSettingsView brand={brand} />;
};

export default GeneralBrandSettings;
